const POSITIONS = ['ALL', 'QB', 'RB', 'WR', 'TE', 'K', 'DEF'];

function PositionFilter({ selected, onChange }) {
  return (
    <div className='filter-group'>
      {POSITIONS.map(pos => (
        <button
          key={pos}
          className={`filter-pill ${selected === pos ? 'active' : ''}`}
          onClick={() => onChange(pos)}
        >
          {pos}
        </button>
      ))}
    </div>
  );
}

export default PositionFilter;
